var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "upload-block"
  }, [_c("el-upload", {
    staticClass: "upload-demo",
    attrs: {
      drag: "",
      multiple: "",
      "auto-upload": false,
      "on-change": _vm.handleChange,
      "before-remove": _vm.beforeRemove,
      accept: "image/*",
      "list-type": "picture",
      "show-file-list": false,
      width: "1080",
      height: "1080"
    }
  }, [_c("i", {
    staticClass: "el-icon-upload",
    staticStyle: {
      "font-size": "28px"
    }
  }), _c("div", {
    staticClass: "el-upload__text"
  }, [_vm._v(" Drop images here or click to select ")]), _c("div", {
    staticClass: "el-upload__tip",
    attrs: {
      slot: "tip"
    },
    slot: "tip"
  }, [_vm._v(" You can upload single or multiple images ")])]), _vm._m(0), _c("el-divider"), _c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center",
      gap: "12px",
      "margin-top": "12px"
    }
  }, [_vm.uploadedImages.length ? _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: _vm.uploadAll
    }
  }, [_vm._v(" Upload All ")]) : _vm._e(), _vm.uploadedImages.length ? _c("el-radio-group", {
    attrs: {
      size: "mini"
    },
    model: {
      value: _vm.statusFilter,
      callback: function ($$v) {
        _vm.statusFilter = $$v;
      },
      expression: "statusFilter"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "all"
    }
  }, [_vm._v(" All (" + _vm._s(_vm.uploadedImages.length) + ") ")]), _c("el-radio-button", {
    attrs: {
      label: "ready"
    }
  }, [_vm._v(" Ready (" + _vm._s(_vm.countByStatus("ready")) + ") ")]), _c("el-radio-button", {
    attrs: {
      label: "uploaded"
    }
  }, [_vm._v(" Uploaded (" + _vm._s(_vm.countByStatus("uploaded")) + ") ")]), _c("el-radio-button", {
    attrs: {
      label: "failed"
    }
  }, [_vm._v(" Failed (" + _vm._s(_vm.countByStatus("failed")) + ") ")]), _c("el-radio-button", {
    attrs: {
      label: "uploading"
    }
  }, [_vm._v(" Uploading (" + _vm._s(_vm.countByStatus("uploading")) + ") ")])], 1) : _vm._e()], 1)], 1), _vm.uploadedImages.length ? _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.filteredImages,
      size: "small",
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Preview",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-image", {
          staticStyle: {
            width: "80px",
            height: "80px",
            "object-fit": "contain"
          },
          attrs: {
            src: scope.row.url,
            fit: "contain"
          }
        }, [_c("div", {
          staticClass: "image-slot",
          attrs: {
            slot: "error"
          },
          slot: "error"
        }, [_c("i", {
          staticClass: "el-icon-picture-outline"
        })])])];
      }
    }], null, false, 3351416978)
  }), _c("el-table-column", {
    attrs: {
      label: "Product ID",
      prop: "id",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.id || "-"))])];
      }
    }], null, false, 2835223441)
  }), _c("el-table-column", {
    attrs: {
      label: "Product Name",
      prop: "productName",
      width: "260",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.productName || "-"))])];
      }
    }], null, false, 488262448)
  }), _c("el-table-column", {
    attrs: {
      prop: "name",
      label: "Filename",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "Size",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm.formatSize(scope.row.size)) + " ")];
      }
    }], null, false, 3314639679)
  }), _c("el-table-column", {
    attrs: {
      label: "Status",
      width: "200",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.status === "uploading" ? _c("div", [_c("el-progress", {
          attrs: {
            percentage: scope.row.progress || 0,
            status: "active"
          }
        })], 1) : _c("div", [_c("el-tag", {
          attrs: {
            type: _vm.statusToTag(scope.row.status)
          }
        }, [_vm._v(" " + _vm._s(scope.row.status) + " ")])], 1)];
      }
    }], null, false, 113374729)
  }), _c("el-table-column", {
    attrs: {
      label: "Actions",
      width: "180",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", {
          staticClass: "action-buttons"
        }, [_c("el-button", {
          attrs: {
            type: "danger",
            size: "mini"
          },
          on: {
            click: function ($event) {
              return _vm.removeImage(scope.$index, scope.row);
            }
          }
        }, [_vm._v(" Remove ")]), scope.row.status !== "uploaded" ? _c("el-button", {
          attrs: {
            type: "success",
            size: "mini"
          },
          on: {
            click: function ($event) {
              return _vm.uploadOne(scope.row);
            }
          }
        }, [_vm._v(" Upload ")]) : _vm._e()], 1)];
      }
    }], null, false, 1459060948)
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "upload-note",
    staticStyle: {
      "text-align": "center",
      "margin-top": "8px"
    }
  }, [_c("small", [_vm._v("File name should be exactly same as Catalogue code.")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };